import React from 'react';
import { Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import CustomButton from '../../../components/buttons/CustomButton';
import styles from './PackagesEmptyState.module.css';

const STEPS = [
  { Icon: LayersOutlinedIcon, title: 'Junte sessões', text: 'De um ou mais procedimentos.' },
  { Icon: LocalOfferOutlinedIcon, title: 'Dê um preço', text: 'O desconto sobre o avulso aparece na hora.' },
  { Icon: EventAvailableOutlinedIcon, title: 'Defina a validade', text: 'Em dias, ou sem prazo.' },
];

/** Nenhum pacote ainda: ilustração leve, como funciona em três passos e o atalho para criar. */
function PackagesEmptyState({ canManage, deniedReason, onCreate }) {
  return (
    <section className={styles.card}>
      <div className={styles.illustration} aria-hidden="true">
        <span className={styles.halo} />
        <span className={styles.box}><Inventory2OutlinedIcon /></span>
        <span className={`${styles.badge} ${styles.badgeLeft}`}>3x</span>
        <span className={`${styles.badge} ${styles.badgeRight}`}>-10%</span>
      </div>

      <h3 className={styles.title}>Nenhum pacote cadastrado</h3>
      <p className={styles.text}>
        Venda várias sessões de uma vez, com preço fechado e validade.
      </p>

      <ol className={styles.steps}>
        {STEPS.map(({ Icon, title, text }) => (
          <li key={title} className={styles.step}>
            <span className={styles.stepIcon}><Icon fontSize="small" /></span>
            <span className={styles.stepTitle}>{title}</span>
            <span className={styles.stepText}>{text}</span>
          </li>
        ))}
      </ol>

      <Tooltip title={canManage ? '' : deniedReason} arrow>
        <span>
          <CustomButton
            style="main"
            variant="contained"
            icon={<AddIcon />}
            label="Criar primeiro pacote"
            onClick={onCreate}
            disabled={!canManage}
          />
        </span>
      </Tooltip>
    </section>
  );
}

export default PackagesEmptyState;
